// extracted by mini-css-extract-plugin
module.exports = {"container":"_638e4a0"};